module.exports = __webpack_public_path__ + "img/highmast_electrical_fault.8a244840.svg";